import React from 'react';
import { useTranslations } from '../translations';
import { appLinkClick, createPageUrl } from '../utils/appRoutes';
import './PrivacyNotice.css';

interface PrivacyNoticeProps {
  onNavigateToPrivacy?: () => void;
}

/** Tells the person where their data goes at the moment a form collects it; it is information, not a consent. */
const PrivacyNotice: React.FC<PrivacyNoticeProps> = ({ onNavigateToPrivacy }) => {
  const t = useTranslations();

  return (
    <p className="privacy-notice">
      {t.register.privacyNotice}{' '}
      <a
        className="privacy-notice-link"
        href={createPageUrl('privacy')}
        onClick={onNavigateToPrivacy ? appLinkClick(onNavigateToPrivacy) : undefined}
      >
        {t.register.privacyNoticeLink}
      </a>.
    </p>
  );
};

export default PrivacyNotice;
